module.exports = __webpack_public_path__ + "3ac0ce50a05a87154abe94a1740fe6d2.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/paquete.png
// module id = 2161
// module chunks = 0